const namePrefixesByType = {
  0: "SO",
  1: "Return",
  2: "PO",
  4: "Delivery",
  5: "CSH",
};

const normalizeUnsyncedTransactions = () => {
  const parsedTransactions = JSON.parse(
    localStorage.getItem("UnsyncedTransactions") || "[]",
  );
  const parsedCounts = JSON.parse(
    localStorage.getItem("UnsyncedTransactionsCount") || "[]",
  );

  const transactions = Array.isArray(parsedTransactions) ? parsedTransactions : [];
  const counts = Array.isArray(parsedCounts) ? [...parsedCounts] : [];
  let didChange = false;

  const normalizedTransactions = transactions.map((typeTransactions, typeIndex) => {
    if (!Array.isArray(typeTransactions)) {
      counts[typeIndex] = typeof counts[typeIndex] === "number" ? counts[typeIndex] : 0;
      return typeTransactions;
    }

    const usedIds = new Set();
    let nextId = 0;

    typeTransactions.forEach((item) => {
      if (!item || typeof item !== "object") {
        return;
      }

      const candidateId = Number(item.usId);
      if (Number.isInteger(candidateId) && candidateId >= 0 && !usedIds.has(candidateId)) {
        usedIds.add(candidateId);
        if (candidateId >= nextId) {
          nextId = candidateId + 1;
        }
      }
    });

    const preservedIds = new Set();

    const normalizedTypeTransactions = typeTransactions.map((item, itemIndex) => {
      if (!item || typeof item !== "object") {
        return item;
      }

      const candidateId = Number(item.usId);
      const hasValidUniqueId =
        Number.isInteger(candidateId) &&
        candidateId >= 0 &&
        candidateId < nextId &&
        !preservedIds.has(candidateId);

      const expectedNamePrefix = namePrefixesByType[typeIndex];
      const expectedName = expectedNamePrefix
        ? `${expectedNamePrefix}${itemIndex + 1}`
        : item.name;

      if (hasValidUniqueId) {
        preservedIds.add(candidateId);

        if (expectedNamePrefix && item.name !== expectedName) {
          didChange = true;
          return { ...item, name: expectedName };
        }

        return item;
      }

      while (usedIds.has(nextId)) {
        nextId += 1;
      }

      usedIds.add(nextId);
      didChange = true;
      const normalizedItem = {
        ...item,
        usId: nextId,
        ...(expectedNamePrefix ? { name: expectedName } : {}),
      };
      nextId += 1;
      return normalizedItem;
    });

    if (counts[typeIndex] !== nextId) {
      counts[typeIndex] = nextId;
      didChange = true;
    }

    return normalizedTypeTransactions;
  });

  if (didChange) {
    localStorage.setItem(
      "UnsyncedTransactions",
      JSON.stringify(normalizedTransactions),
    );
    localStorage.setItem(
      "UnsyncedTransactionsCount",
      JSON.stringify(counts),
    );
  }

  return {
    transactions: normalizedTransactions,
    counts,
    didChange,
  };
};

export default normalizeUnsyncedTransactions;